import { render, staticRenderFns } from "./error-tips.vue?vue&type=template&id=3f69d092&scoped=true&"
import script from "./error-tips.vue?vue&type=script&lang=js&"
export * from "./error-tips.vue?vue&type=script&lang=js&"
import style0 from "./error-tips.vue?vue&type=style&index=0&id=3f69d092&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69d092",
  null
  
)

export default component.exports